import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const WinReductionRowWrapper = styled('div', { label: 'WinReductionRowWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
`;

export const WinReductionInfo = withConfig(theme => styled('div', { label: 'WinReductionInfo' })`
    font-size: ${theme.star.fontSize.xSmall};
    color: ${theme.star.betslipSummary.txtColor};
    display: flex;
    align-items: center;
    gap: 4px;
`);

export const WinReductionAmount = withConfig(theme => styled('div', { label: 'WinReductionAmount' })`
    font-size: ${theme.star.fontSize.small};
    color: ${theme.star.betslipGeneral.txtColorTertiary};
    font-weight: ${theme.star.fontWeight.bold};
`);
